export default __webpack_public_path__ + "static/banner-af35a977e8fdaf44601d798529d0ffc8.jpg";